import React, {useState} from 'react';
import classNames from 'classnames';
import {getMPPEndpoint, getHeaders} from '../../../../../../helpers/endpoint';
import {useDispatch} from 'react-redux';
import Loader from '../../../../../../components/Loader';
import DateRangePickerWrapper from '../../../../../../components/DatePicker/DateRangePickerWrapper';
import moment from 'moment';
import {BOGetContestsDurationResponse} from '@fantaleague/mpp_types';

const AverageDurationLeagues = () => {
  const dispatch = useDispatch();

  const [lang, setLang] = useState('fr-FR');
  const [startDate, setStartDate] = useState(
    moment(new Date().setDate(new Date().getDate() - 30)).format('YYYY-MM-DD'),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date().setDate(new Date().getDate())).format('YYYY-MM-DD'),
  );
  const [leagueStats, setLeagueStats] = useState<
    BOGetContestsDurationResponse | undefined
  >(undefined);
  const [challengesStats, setChallengesStats] = useState<
    BOGetContestsDurationResponse | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const getAverageContestsDuration = () => {
    return (_dispatch, getState) => {
      setIsLoading(true);
      return Promise.all([
        fetch(
          getMPPEndpoint('getAverageContestsDuration', {
            contestType: 'challenge',
            payload: {startDate: startDate, endDate: endDate},
          }),
          {
            method: 'GET',
            headers: getHeaders(getState().authentication),
          },
        ).then(value => value.json()),
        fetch(
          getMPPEndpoint('getAverageContestsDuration', {
            contestType: 'league',
            payload: {startDate: startDate, endDate: endDate},
          }),
          {
            method: 'GET',
            headers: getHeaders(getState().authentication),
          },
        ).then(value => value.json()),
      ])
        .then(([challengeData, leagueData]) => {
          setLeagueStats(leagueData);
          setChallengesStats(challengeData);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
        });
    };
  };

  const renderLeaguesByModeByStatus = () => {
    if (!leagueStats || !challengesStats) {
      return null;
    }
    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Type de ligue</th>
              <th className="text-center">Journées</th>
            </tr>
          </thead>
          <tbody>
            <tr
              key={`challenge-average-duration`}
              data-toggle="collapse"
              data-target={`.challenge-average-duration`}>
              <td style={{width: '150px '}}>Classique</td>
              <td className="text-center">
                <b>
                  {(challengesStats.averageGameWeekQuantity || 0).toFixed(1)}
                </b>
              </td>
            </tr>
            <tr
              key={`league-average-duration`}
              data-toggle="collapse"
              data-target={`.league-average-duration`}>
              <td style={{width: '150px '}}>1vs1</td>
              <td className="text-center">
                <b>{(leagueStats.averageGameWeekQuantity || 0).toFixed(1)}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="leagues-stats-widget">
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title pull-left">
            <i className="fa fa-calendar" /> Durée moyenne des ligues
          </h3>
        </div>
        <div className="box-body">
          <div className="text-center">
            <div className="inline lang">
              <button
                className={classNames('btn btn-box-tool', {
                  selected: lang === 'fr-FR',
                })}
                onClick={() => setLang('fr-FR')}>
                <span className="flag-icon flag-icon-fr" />
              </button>
            </div>
            <div className="period-filter inline data-range-picker">
              <DateRangePickerWrapper
                initialStartDate={moment(startDate)}
                initialEndDate={moment(endDate)}
                minimumNights={0}
                onDatesChange={({startDate, endDate}) => {
                  setStartDate(moment(startDate).format('YYYY-MM-DD'));
                  setEndDate(moment(endDate).format('YYYY-MM-DD'));
                }}
              />
              <button
                className="mb-1 inline btn btn-default btn-flat"
                onClick={() => dispatch(getAverageContestsDuration())}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
        </div>
        {isLoading && <Loader />}
        {renderLeaguesByModeByStatus()}
      </div>
    </div>
  );
};

export default AverageDurationLeagues;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/components/AverageDurationLeagues/index.tsx